'use client';

import React from 'react';

import { themeClasses } from '@repo/ui-kit/css/utils';

import { CenterVariation } from './CenterVariation/CenterVariation';
import { Companies } from './Companies/Companies';
import { Background, Wrapper } from './styles';
import { TwoColumnsVariation } from './TwoColumnVariation/TwoColumnsVariation';
import { BannerProps } from './types';

export const Banner: React.FC<BannerProps> = (props) => {
  return (
    <Wrapper>
      <Background
        backgroundGradient={props.backgroundGradient}
        className={themeClasses.dark}
      >
        {props.layout === 'twoColumns' ? (
          <TwoColumnsVariation
            button={props.button}
            buttonMeta={props.buttonMeta}
            description={props.description}
            image={props.image}
            isHeadline={props.size === 'hero'}
            title={props.title}
          />
        ) : (
          <CenterVariation
            button={props.button}
            buttonMeta={props.buttonMeta}
            description={props.description}
            image={props.image}
            imageSize={props.imageSize}
            title={props.title}
          />
        )}
      </Background>
      {props.showCompanies && <Companies />}
    </Wrapper>
  );
};
